export default __webpack_public_path__ + "static/media/empty.e733b6a8.png";